import { useRef } from 'libs/react';
import { React } from 'libs/react';
import './TextAreaInput.scss';
/**
 * @component TextAreaInput
 * @since 1.0.0
 * @hidden
 */
export function TextAreaInput(props) {
    const { name, ident, value, required, disabled, placeholder, autoselect, autocorrect, autocomplete, autocapitalize, rows } = props;
    const node = useRef(null);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        if (props.onBlur) {
            props.onBlur();
        }
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        if (autoselect && node.current) {
            node.current.select();
        }
        if (props.onFocus) {
            props.onFocus();
        }
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(e) {
        if (props.onChange) {
            props.onChange(e.currentTarget.value);
        }
    }
    /**
     * @function onKeyDown
     * @since 1.0.0
     * @hidden
     */
    function onKeyDown(e) {
        if (e.key === 'Enter') {
            e.stopPropagation();
        }
    }
    return (React.createElement("textarea", { id: ident, ref: node, name: name, value: value, required: required, disabled: disabled, placeholder: placeholder, autoCorrect: autocorrect ? 'on' : 'off', autoComplete: autocomplete ? 'on' : 'off', autoCapitalize: autocapitalize ? 'on' : 'off', rows: rows, onBlur: onBlur, onFocus: onFocus, onInput: onChange, onChange: onChange, onKeyDown: onKeyDown }));
}
